<ng-container *transloco="let t; prefix: 'unsubscribeFeatures'">
  <rma-navigation-header redirectUrl="/manage-account/billing" />
  @let featureKeys = featureKeys$ | async;
  <mat-card class="md:p-auto mx-auto w-full max-w-3xl px-4 py-6 md:my-8">
    @if (featureKeys) {
      <mat-card-header>
        <h2 class="text-heading-2">{{ t('features.title') }}</h2>
      </mat-card-header>

      <mat-card-content>
        <ul *transloco="let tSub; prefix: 'subscriptions.card.features'" class="flex flex-col gap-3">
          @for (feature of featureKeys; track feature) {
            <li class="flex gap-2.5">
              <rma-icon class="shrink-0 text-warning-50" glyph="close" />
              <div class="flex flex-col gap-0.5">
                <strong>{{ tSub('shortname.' + feature) }}</strong>
                <div class="text-steel-70">
                  {{ tSub('tooltip.' + feature) }}
                </div>
              </div>
            </li>
          }
        </ul>
      </mat-card-content>
    }
    <mat-card-actions class="flex justify-between">
      <a mat-button color="primary" routerLink="/manage-account/billing">{{ t('warning.cancel') }}</a>
      <button type="button" (click)="onDowngrade()" mat-flat-button color="primary">{{ t('warning.cta') }}</button>
    </mat-card-actions>
  </mat-card>
</ng-container>
